import { useEffect, useState } from "react";
import axios from "axios";
import { FORUM_REPORT_DATE_RANGE } from "../routes/routes";

function resolveChapterId(chapterId) {
  if (chapterId) return chapterId;
  try {
    const user = JSON.parse(localStorage.getItem("user") || "null");
    // Circle Admin (3) and Member (4) are chapter-scoped
    if (user && [3, 4].includes(Number(user.user_type)) && user.chapter_id) {
      return user.chapter_id;
    }
  } catch {
    /* ignore */
  }
  return "";
}

/**
 * Fetches rolling period date range for a chapter.
 * Requires chapterId (or chapter-scoped auth user) — otherwise empty dates.
 * ready=true even on failure so list pages do not hang.
 */
export function useForumReportDateRange(chapterId = "") {
  const [from_date, setFromDate] = useState("");
  const [to_date, setToDate] = useState("");
  const [launching_date, setLaunchingDate] = useState("");
  const [rolling_period_months, setRollingPeriodMonths] = useState(12);
  const [ready, setReady] = useState(false);

  const effectiveChapterId = resolveChapterId(chapterId);

  useEffect(() => {
    let cancelled = false;

    if (!effectiveChapterId) {
      setFromDate("");
      setToDate("");
      setLaunchingDate("");
      setRollingPeriodMonths(12);
      setReady(true);
      return () => {
        cancelled = true;
      };
    }

    setReady(false);
    axios
      .get(FORUM_REPORT_DATE_RANGE, {
        params: { chapter_id: effectiveChapterId },
      })
      .then((res) => {
        if (cancelled) return;
        if (res.status === 200 && res.data.success && res.data.data) {
          setFromDate(res.data.data.from_date || "");
          setToDate(res.data.data.to_date || "");
          setLaunchingDate(res.data.data.launching_date || "");
          setRollingPeriodMonths(
            Number(res.data.data.rolling_period_months) || 12
          );
        }
      })
      .catch(() => {
        if (cancelled) return;
        setFromDate("");
        setToDate("");
        setLaunchingDate("");
      })
      .finally(() => {
        if (!cancelled) setReady(true);
      });

    return () => {
      cancelled = true;
    };
  }, [effectiveChapterId]);

  return {
    from_date,
    to_date,
    launching_date,
    forum_launch_date: launching_date,
    rolling_period_months,
    ready,
  };
}

export default useForumReportDateRange;
